<script>
import TablePage from '@/found/components/table_page';

export default {
  name: 'terminal_scan_list',
  extends: TablePage,
  data() {
    return {};
  },
  props: {
    propsObj: Object,
  },
  async created() {
    this.params = { oldId: this.propsObj.row.id };
    await this.getConfigList('regionOldRecordList');
  },
};
</script>
